'use client';
import React from 'react';

type TabKey = 'reviews' | 'saved' | 'settings';

interface Props {
  activeTab: TabKey;
  onChange: (tab: TabKey) => void;
  reviewCount: number;
  savedCount: number;
}

const TABS: { key: TabKey; label: string; emoji: string }[] = [
  { key: 'reviews', label: 'Ulasanku', emoji: '✍️' },
  { key: 'saved', label: 'Tersimpan', emoji: '🔖' },
  { key: 'settings', label: 'Pengaturan', emoji: '⚙️' },
];

export default function ProfilTabs({ activeTab, onChange, reviewCount, savedCount }: Props) {
  return (
    <div className="flex border-b border-border">
      {TABS.map((tab) => {
        const count = tab.key === 'reviews' ? reviewCount : tab.key === 'saved' ? savedCount : null;
        return (
          <button
            key={`ptab-${tab.key}`}
            onClick={() => onChange(tab.key)}
            className={`flex items-center gap-2 px-5 py-3 text-sm font-600 border-b-2 transition-all -mb-px ${
              activeTab === tab.key
                ? 'border-accent text-accent' :'border-transparent text-muted-foreground hover:text-primary'
            }`}
          >
            <span>{tab.emoji}</span>
            {tab.label}
            {count !== null && (
              <span className={`text-xs rounded-full px-1.5 py-0.5 font-700 font-tabular ${activeTab === tab.key ? 'bg-accent/10 text-accent' : 'bg-muted text-muted-foreground'}`}>
                {count}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}